var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBigSignature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.79,25.49l-2.83-2.83,5.41-5.41h2.83l7.7,7.7v2.83l-5.41,5.41-2.83-2.83,4-4-4.87-4.87-4,4Zm-24.79,40.18l29.78-29.78-2.83-2.83-29.51,29.51-8.6,3.73,3.73-8.6,29.51-29.51-2.83-2.83L14.48,55.14l-.42,.62-5.9,13.59,2.63,2.63,13.59-5.9,.62-.42Zm-1.2,6.33v4H92v-4H23.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigSignature);
export default __webpack_public_path__ + "static/1779176049/media/icon-big-signature.01f14f2245f2ecd33536e9cbfbfff300.svg";
export { ForwardRef as ReactComponent };